import { pages } from '@/services/Api'

export default {
  getLanding(id = '') {
    return pages.post('/graphql', {
      query: `
          query FetchPage($id: ID!) {
            page(id: $id) {
              id
              name
              title
              category
              published
              draft
              settings
              template
              compiled
              createdAt
              updatedAt
              type
            }
          }
        `,
      variables: {
        id,
      },
    })
  },
  setLanding(id = '', { landing = [], settings = {}, preCompiled = '', compiled = '', published = false }) {
    return pages.post('/graphql', {
      query: `
        mutation SavePage($input: SavePageInput!) {
          savePage(input: $input) {
            id
            published
            name
            title
            category
            draft
            settings
          }
        }
      `,
      variables: {
        input: {
          id,
          published,
          data: landing,
          draft: landing,
          settings,
          template: preCompiled,
          compiled,
        },
      },
    })
  },

  setDraft(id = '', { draft = [], settings = {} }) {
    return pages.post('/graphql', {
      query: `
        mutation SavePage($input: SavePageInput!) {
          savePage(input: $input) {
            id
            name
            title
            category
            draft
            settings
          }
        }
      `,
      variables: {
        input: {
          id,
          draft,
          settings,
        },
      },
    })
  },

  setDynamicLanding(params = {}) {
    return pages.post('/graphql', {
      query: `
        mutation SavePage($input: SavePageInput!) {
          savePage(input: $input) {
            id
            name
            title
            createdAt
            updatedAt
          }
        }
      `,
      variables: {
        input: params,
      },
    })
  },

  savePageAsTheme({ id = '', name = '', category = '', description = '', locale = '' }) {
    return pages.post('/graphql', {
      query: `
        mutation SavePageAsTheme($input: SavePageAsThemeInput!) {
          savePageAsTheme(input: $input) {
            id
            name
            category
            description
            locale
          }
        }
      `,
      variables: {
        input: { id, name, category, description, locale },
      },
    })
  },
}
